export const hexToRgb = (hex: string) => {
  // Remove leading #
  let cleanedHex = hex.replace(/^#/, "");

  // Expand shorthand (e.g. "f0f" → "ff00ff")
  if (cleanedHex.length === 3) {
    cleanedHex = cleanedHex
      .split("")
      .map((char) => char + char)
      .join("");
  }

  if (cleanedHex.length !== 6) {
    return "";
  }

  const num = parseInt(cleanedHex, 16);

  const r = (num >> 16) & 255;
  const g = (num >> 8) & 255;
  const b = num & 255;

  return `${r}, ${g}, ${b}`;
};
